// import { Box, Typography, Grid, Card, CardContent, Stack, useMediaQuery, CircularProgress } from "@mui/material";
// import { Assignment, AssignmentLate, FiberManualRecord } from "@mui/icons-material";

// import { theme } from "../../theme/theme";
// import { useGetOverviewQuery } from "../../features/api_overview/overviewApi";

// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
// import noRecordsFound from "../../assets/svg/noRecordsFound.svg";

// const Overview = () => {
//   const { data, isLoading, isFetching, isSuccess } = useGetOverviewQuery();
//   const isTablet = useMediaQuery(theme.breakpoints.down("md"));

//   const chartData = data?.value?.[0]?.overviewAnalyticsDetails
//     ?.map((detail) => ({
//       name: detail.fullName,
//       Tickets: detail.numberOfTicket,
//       OnTime: Number(detail.numberOfTicket) - Number(detail.numberOfDelay),
//       Delays: detail.numberOfDelay,
//       percentageTicket: detail.percentageTicket,
//       delayTicketPercentage: detail.delayTicketPercentage,
//     }))
//     ?.sort((a, b) => b.Tickets - a.Tickets);

//   return (
//     <Stack
//       sx={{
//         width: "100%",
//         height: "auto",
//         display: "flex",
//         backgroundColor: theme.palette.bgForm.black1,
//         color: "#fff",
//         padding: isTablet ? "10px" : "15px 94px 25px 94px",
//         boxSizing: "border-box",
//       }}
//     >
//       <Stack justifyItems="left" mb={2}>
//         <Typography variant="h4">Overview</Typography>
//       </Stack>

//       <Grid container spacing={2}>
//         {/* Cards */}
//         <Grid item xs={12} sm={6} md={4}>
//           <Card sx={{ width: "100%", height: "100%", backgroundColor: "#111927" }}>
//             <CardContent>
//               <Stack direction="row" spacing={2} alignItems="center">
//                 {/* Icon with Shadowed Circle */}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     width: "100%",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     width: 48,
//                     height: 48,
//                     backgroundColor: "#9e77ed",
//                     borderRadius: "50%",
//                     boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
//                   }}
//                 >
//                   <Assignment sx={{ color: "#fff" }} />
//                 </Box>

//                 <Box>
//                   <Typography sx={{ fontWeight: 400, fontSize: "1rem", lineHeight: 1.5, color: "#9fa6ad" }}>Total Tickets:</Typography>
//                   <Typography variant="h4">{data?.value[0]?.totalTicket ? data?.value[0]?.totalTicket : "0"}</Typography>
//                 </Box>
//               </Stack>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <Card sx={{ width: "100%", height: "100%", backgroundColor: "#111927" }}>
//             <CardContent>
//               <Stack direction="row" spacing={2} alignItems="center">
//                 {/* Icon with Shadowed Circle */}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     width: "50%",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     width: 48,
//                     height: 48,
//                     backgroundColor: theme.palette.error.main,
//                     borderRadius: "50%",
//                     boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
//                   }}
//                 >
//                   <AssignmentLate sx={{ color: "#fff" }} />
//                 </Box>

//                 <Box>
//                   <Typography sx={{ fontWeight: 400, fontSize: "1rem", lineHeight: 1.5, color: "#9fa6ad" }}>Delayed Tickets:</Typography>
//                   <Typography variant="h4">{data?.value[0]?.totalDelay ? data?.value[0]?.totalDelay : "0"}</Typography>
//                 </Box>
//               </Stack>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Bar Chart Section */}
//       <Box mt={4} padding={2} sx={{ backgroundColor: theme.palette.bgForm.black3, minHeight: "560px" }}>
//         <Stack direction="row" gap={0.5} alignItems="center" justifyContent="center" sx={{ width: "100%" }} mb={2} mt={2}>
//           <Typography gutterBottom sx={{ color: "#8884d8", fontSize: "17px", fontWeight: 600 }}>
//             Ticket Distribution (Ranked by Tickets)
//           </Typography>
//         </Stack>

//         <ResponsiveContainer width="100%" height={chartData?.length * 40}>
//           <BarChart data={chartData} layout="vertical">
//             <CartesianGrid stroke="#ccc" horizontal={false} />
//             <XAxis type="number" domain={[0, 5]} />
//             <YAxis type="category" dataKey="name" width={150} tick={{ fill: "#fff", fontSize: "12px" }} interval={0} />
//             <Tooltip content={<CustomTooltip />} cursor={{ fill: "#3f305f" }} />

//             <Bar dataKey="Tickets" fill="#8884d8" label={{ position: "right", fill: "#fff", fontSize: 12 }} name="Total Tickets" />
//             <Bar
//               dataKey="Delays"
//               fill="#FF6347"
//               label={{
//                 position: "right",
//                 fill: "#fff",
//                 fontSize: 12,
//                 formatter: (value) => (value > 0 ? value : ""),
//               }}
//               name="Total Delay (%)"
//             />
//           </BarChart>

//           {(isLoading || isFetching) && (
//             <Stack sx={{ width: "100%", gap: 1, justifyContent: "center", alignItems: "center" }}>
//               <CircularProgress />
//               <Typography variant="h5" color="#EDF2F7">
//                 Please wait...
//               </Typography>
//             </Stack>
//           )}

//           {isSuccess && !chartData?.length && (
//             <Stack sx={{ width: "100%", gap: 1, justifyContent: "center", alignItems: "center" }}>
//               <img src={noRecordsFound} alt="No Records Found" className="norecords-found-table" />
//               <Typography variant="h5" color="#EDF2F7" marginLeft={2}>
//                 No Tickets Available.
//               </Typography>
//             </Stack>
//           )}
//         </ResponsiveContainer>
//       </Box>
//     </Stack>
//   );
// };

// export default Overview;

// const CustomTooltip = ({ active, payload, label }) => {
//   if (active && payload && payload?.length) {
//     const details = payload[0].payload;
//     return (
//       <Box
//         sx={{
//           backgroundColor: "#111927",
//           borderRadius: "8px",
//           padding: "10px",
//           color: "#fff",
//           boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
//         }}
//       >
//         <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>{label}</Typography>
//         <Typography mt={1} sx={{ color: "#8884d8", fontSize: "13px", fontWeight: 500 }}>
//           Total Tickets: {details.Tickets}
//         </Typography>

//         <Typography sx={{ color: theme.palette.error.main, fontSize: "13px", fontWeight: 500 }}>Total Delays: {details.Delays}</Typography>

//         <Stack mt={0.5}>
//           <Stack direction="row" gap={0.5} alignItems="center">
//             <FiberManualRecord color="primary" sx={{ fontSize: "12px" }} />
//             <Typography sx={{ color: "#fff", fontSize: "12px" }}>Ticket Percentage: {details.percentageTicket}%</Typography>
//           </Stack>

//           <Stack direction="row" gap={0.5} alignItems="center">
//             <FiberManualRecord color="error" sx={{ fontSize: "12px" }} />
//             <Typography sx={{ color: "#fff", fontSize: "12px" }}>Delay Percentage: {details.delayTicketPercentage}%</Typography>
//           </Stack>
//         </Stack>
//       </Box>
//     );
//   }
//   return null;
// };

import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { useGetOverviewQuery } from "../../features/api_overview/overviewApi";

const TrendingUpIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);

const TrendingDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
    <polyline points="17 18 23 18 23 12" />
  </svg>
);

const AssignmentIcon = ({ color }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
  </svg>
);

const CheckIcon = ({ color }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <path d="M22 4L12 14.01l-3-3" />
  </svg>
);

const AlertIcon = ({ color }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const ClockIcon = ({ color }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </svg>
);

const Overview = () => {
  const { data, isLoading, isFetching, isSuccess } = useGetOverviewQuery();

  const chartData = data?.value?.[0]?.overviewAnalyticsDetails
    .map((detail) => ({
      name: detail.fullName,
      Total: detail.numberOfTicket,
      Open: detail.openTicketCount,
      OnTime: Number(detail.numberOfTicket) - Number(detail.numberOfDelay),
      Delayed: Number(detail.numberOfDelay),
      percentageTicket: detail.percentageTicket,
      delayTicketPercentage: detail.delayTicketPercentage,
    }))
    .sort((a, b) => b.Total - a.Total);

  console.log("Chart Data: ", chartData);

  const MetricCard = ({ icon: Icon, title, value, trend, color, subtitle }) => {
    const [isHovered, setIsHovered] = React.useState(false);

    return (
      <div
        style={{
          background: "linear-gradient(135deg, #1a1f2e 0%, #252b3b 100%)",
          borderRadius: "16px",
          border: isHovered ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid rgba(255, 255, 255, 0.05)",
          padding: "15px",
          transition: "all 0.3s ease",
          transform: isHovered ? "translateY(-4px)" : "translateY(0)",
          boxShadow: isHovered ? "0 12px 24px rgba(0, 0, 0, 0.4)" : "none",
          cursor: "pointer",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 46,
                height: 46,
                background: `linear-gradient(135deg, ${color}40 0%, ${color}20 100%)`,
                borderRadius: "14px",
                border: `1px solid ${color}30`,
              }}
            >
              <Icon color={color} />
            </div>

            {trend !== undefined && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  padding: "4px 12px",
                  borderRadius: "12px",
                  backgroundColor: trend > 0 ? "#10b98120" : "#ef444420",
                  color: trend > 0 ? "#10b981" : "#ef4444",
                  fontSize: "13px",
                  fontWeight: 600,
                }}
              >
                {trend > 0 ? <TrendingUpIcon /> : <TrendingDownIcon />}
                {Math.abs(trend)}%
              </div>
            )}
          </div>

          <div>
            <div
              style={{
                fontSize: "0.875rem",
                color: "#9fa6ad",
                fontWeight: 500,
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                marginBottom: "4px",
              }}
            >
              {title}
            </div>
            <div
              style={{
                fontSize: "2rem",
                fontWeight: 700,
                color: "#fff",
                letterSpacing: "-0.5px",
                lineHeight: 1,
              }}
            >
              {value}
            </div>
            {subtitle && (
              <div
                style={{
                  fontSize: "0.813rem",
                  color: "#6b7280",
                  marginTop: "4px",
                }}
              >
                {subtitle}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const ProgressCard = ({ title, value, total, color }) => {
    const [isHovered, setIsHovered] = React.useState(false);
    const percentage = (value / total) * 100;

    return (
      <div
        style={{
          background: "linear-gradient(135deg, #1a1f2e 0%, #252b3b 100%)",
          borderRadius: "16px",
          border: "1px solid rgba(255, 255, 255, 0.05)",
          padding: "15px",
          transition: "all 0.3s ease",
          transform: isHovered ? "translateY(-4px)" : "translateY(0)",
          boxShadow: isHovered ? "0 12px 24px rgba(0, 0, 0, 0.4)" : "none",
          cursor: "pointer",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div
              style={{
                fontSize: "0.875rem",
                color: "#9fa6ad",
                fontWeight: 500,
                letterSpacing: "0.5px",
                textTransform: "uppercase",
              }}
            >
              {title}
            </div>
            <div
              style={{
                fontSize: "1.5rem",
                fontWeight: 700,
                color: color,
              }}
            >
              {percentage.toFixed(2)}%
            </div>
          </div>

          <div
            style={{
              height: 8,
              borderRadius: 4,
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${percentage}%`,
                height: "100%",
                backgroundColor: color,
                borderRadius: 4,
                transition: "width 0.6s ease",
              }}
            />
          </div>

          <div
            style={{
              fontSize: "0.813rem",
              color: "#6b7280",
            }}
          >
            {value} of {total} tickets
          </div>
        </div>
      </div>
    );
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;

      console.log("Payload: ", data);
      return (
        <div
          style={{
            background: "linear-gradient(135deg, #1a1f2e 0%, #252b3b 100%)",
            borderRadius: "12px",
            padding: "16px",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.5)",
            minWidth: "220px",
          }}
        >
          <div style={{ fontSize: "14px", fontWeight: 700, color: "#fff", marginBottom: "12px" }}>{data.name}</div>

          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#8b9dc3", fontSize: "13px" }}>Total Tickets:</span>
              <span style={{ color: "#fff", fontSize: "13px", fontWeight: 600 }}>
                {data.Total} ({data.percentageTicket}%)
              </span>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#ff9800", fontSize: "13px" }}>Open:</span>
              <span style={{ color: "#fff", fontSize: "13px", fontWeight: 600 }}>{data.Open}</span>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#10b981", fontSize: "13px" }}>On Time:</span>
              <span style={{ color: "#fff", fontSize: "13px", fontWeight: 600 }}>{data.OnTime}</span>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#ef4444", fontSize: "13px" }}>Delayed:</span>
              <span style={{ color: "#fff", fontSize: "13px", fontWeight: 600 }}>
                {data.Delayed} {data.Delayed > 0 && `(${data.delayTicketPercentage}%)`}
              </span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#0E1320",
        color: "#fff",
        padding: "0px 94px 25px 94px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "22px", maxWidth: "1400px", margin: "0 auto" }}>
        {/* Header */}
        <div>
          <h1
            style={{
              fontSize: "2.25rem",
              fontWeight: 700,
              letterSpacing: "-1px",
              background: "linear-gradient(135deg, #fff 0%, #9fa6ad 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              margin: "0 0 2px 0",
            }}
          >
            Overview
          </h1>
          <p style={{ color: "#6b7280", fontSize: "0.938rem", margin: 0 }}>Monitor your ticket performance and analytics</p>
        </div>

        {/* Main Metrics */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "24px",
          }}
        >
          <MetricCard icon={AssignmentIcon} title="Total Tickets" value={data?.value?.[0]?.totalTicket} color="#8b9dc3" subtitle="All time" />

          <MetricCard
            icon={CheckIcon}
            title="Completed"
            value={data?.value?.[0]?.completedTickets}
            // trend={staticData.trends.completion}
            color="#10b981"
            subtitle={`${data?.value?.[0]?.completionRate}% completion rate`}
          />

          <MetricCard
            icon={AlertIcon}
            title="Delayed"
            value={data?.value?.[0]?.totalDelay}
            // trend={staticData.trends.delays}
            color="#ef4444"
            subtitle={`${((data?.value?.[0]?.totalDelay / data?.value?.[0]?.totalTicket) * 100).toFixed(1)}% of total`}
          />

          <MetricCard icon={ClockIcon} title="Avg Resolution" value={data?.value?.[0]?.avgResolutionTime} color="#f59e0b" subtitle="Per ticket" />
        </div>

        {/* Progress Metrics */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "24px",
          }}
        >
          <ProgressCard title="Completion Rate" value={data?.value?.[0]?.completedTickets} total={data?.value?.[0]?.totalTicket} color="#9e77ed" />
          <ProgressCard title="On-Time Performance" value={data?.value?.[0]?.totalTicket - data?.value?.[0]?.totalDelay} total={data?.value?.[0]?.totalTicket} color="#48BB78" />
        </div>

        {/* Chart Section */}
        <div
          style={{
            background: "linear-gradient(135deg, #1a1f2e 0%, #252b3b 100%)",
            borderRadius: "16px",
            border: "1px solid rgba(255, 255, 255, 0.05)",
            padding: "24px",
          }}
        >
          <div style={{ marginBottom: "24px" }}>
            <h2
              style={{
                fontSize: "1.5rem",
                fontWeight: 700,
                color: "#fff",
                margin: "0 0 8px 0",
              }}
            >
              Ticket Distribution by Issue Handler
            </h2>
            <p style={{ color: "#6b7280", fontSize: "0.875rem", margin: 0 }}>Performance overview ranked by total tickets</p>
          </div>

          <ResponsiveContainer width="100%" height={Math.max(chartData?.length * 80, 270)}>
            <BarChart data={chartData} layout="vertical" margin={{ top: 5, right: 50, left: 5, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.05)" horizontal={false} />
              <XAxis type="number" stroke="#6b7280" style={{ fontSize: "12px" }} />
              <YAxis type="category" dataKey="name" width={140} stroke="#6b7280" style={{ fontSize: "12px" }} interval={0} />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(139, 157, 195, 0.1)" }} />
              <Legend wrapperStyle={{ paddingTop: "120px" }} iconType="rect" />

              <Bar dataKey="Open" stackId="a" fill="#ff9800" name="Open" />
              <Bar dataKey="OnTime" stackId="a" fill="#48bb78" name="On Time" />
              <Bar
                dataKey="Delayed"
                stackId="a"
                fill="#ef5350"
                // radius={[0, 8, 8, 0]}
                name="Delayed"
                label={{
                  position: "right",
                  fill: "#fff",
                  fontSize: 11,
                  formatter: (value, entry) => {
                    if (entry && entry.payload && entry.payload.Total) {
                      return entry.payload.Total;
                    }
                    return "";
                  },
                }}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default Overview;
